export default class Textexpand {
    init(root) {
        this.root = root
        this.button = this.root.querySelector('.textexpand-button');
        this.hiddenText = this.root.querySelector('.textexpand-hiddentext');
        
        // Initialize with hidden text initially hidden
        this.hiddenText.hidden = true;
        this.button.setAttribute('aria-expanded', 'false');
        this.button.setAttribute('aria-controls', this.hiddenText.id);

        this.addEvents();
    }

    addEvents() {
        this.button.addEventListener('click', e => {
            const isExpanded = this.button.getAttribute('aria-expanded') === 'true';

            // Toggle button state and aria-expanded
            if (isExpanded) {
                this.button.setAttribute('aria-expanded', 'false');
                this.hiddenText.hidden = true;
            } else {
                this.button.setAttribute('aria-expanded', 'true');
                this.hiddenText.hidden = false;
            }

            // Toggle the visual state (optional class for custom styles)
            this.root.classList.toggle('is-open');
        });

        // Optional: Add keyboard support (Enter or Space keys)
        this.button.addEventListener('keydown', (event) => {
            if (event.key === ' ' || event.key === 'Enter') {
                event.preventDefault();
                this.button.click();
            }
        });
    }
}
